import PropertyCheckerUserService from '../services/property-checker-user-service';

export const propertyCheckerUser = {
  namespaced: true,
  state: {
    users: null,
    user: null,
  },
  actions: {
    get({ commit }) {
      commit('setIsBusy', true, { root: true });
      return PropertyCheckerUserService.get()
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setUsers', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    newUser({ commit }) {
      const userTemplate = JSON.parse(JSON.stringify({}));
      commit('setUser', userTemplate);
    },
    byEmail({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return PropertyCheckerUserService.byEmail(payload.accountId)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setUser', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          commit('setUser', null);
          return Promise.reject(error);
        });
    },
    invite({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return PropertyCheckerUserService.invite(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setUser', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    resendInvite({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return PropertyCheckerUserService.resendInvite(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setUser', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    enable({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return PropertyCheckerUserService.enable(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setUser', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    disable({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return PropertyCheckerUserService.disable(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setUser', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setUsers(state, newUsers) {
      state.users = newUsers;
    },
    setUser(state, newUser) {
      state.user = newUser;
    },
  },
};
